module.exports = __webpack_public_path__ + "static/img/fish12.f41c868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish12.png
// module id = B6M3
// module chunks = 0